import Component from './PrimaryLayout'

export default Component
